import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";

const modalState = atom<string | null>({
  key: "modalState",
  default: null,
});

const useModalValue = () => useRecoilValue(modalState);
const useSetModal = () => useSetRecoilState(modalState);
const useModalState = () => useRecoilState(modalState);

export { useModalState, useSetModal, useModalValue };
